import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchMonetization } from '../api';

const MonetizationContext = createContext(null);

let adsenseLoaded = false;
function loadAdsense(client) {
  if (adsenseLoaded || !client) return;
  adsenseLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
  s.crossOrigin = 'anonymous';
  document.head.appendChild(s);
}

export function MonetizationProvider({ children }) {
  const [config, setConfig] = useState({
    adsEnabled: false,
    adsenseClient: '',
    adSlots: {},
    leadgenEnabled: true,
    affiliates: [],
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    fetchMonetization()
      .then((d) => {
        setConfig(d);
        if (d.adsEnabled && d.adsenseClient) loadAdsense(d.adsenseClient);
      })
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  const affiliatesFor = (placement) =>
    (config.affiliates || []).filter((a) => (a.placements || []).includes(placement));

  return (
    <MonetizationContext.Provider value={{ ...config, ready, affiliatesFor }}>
      {children}
    </MonetizationContext.Provider>
  );
}

export function useMonetization() {
  const ctx = useContext(MonetizationContext);
  if (!ctx) throw new Error('useMonetization must be used within MonetizationProvider');
  return ctx;
}
